import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, UserControlledObject } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useUserControlledObjectsQuery(
	userGuid: Guid | undefined,
	options?:
		| Omit<UseQueryOptions<UserControlledObject[], unknown, UserControlledObject[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.ControlledObjects(userGuid),
		() =>
			AxiosUtils.getResponseData<UserControlledObject[]>(
				api.get(CerebroApiEndpoints.Users.ControlledObjects(userGuid))
			),
		options
	);
}
